export const TAG_FIELD_NAMES = {
  CURRENCY: 'currency',
  COUNTRY: 'country'
}
